export default class ColaboradorAdapter {
  static toApi(colaboradorStore) {
    return {
      ...colaboradorStore,
      cpf: colaboradorStore.cpf ? colaboradorStore.cpf.replaceAll(/[.,()/\s-]+/g, '') : '',
    }
  }
}